<div class="group-qty" [class.full-width]="fullWidth">
  <button (click)="decrement()" class="btn btn-minus">
    <mat-icon>remove</mat-icon>
  </button>

  <input
    ng-pattern="/^[1-9]*$/"
    type="number"
    [ngModel]="qty"
    (ngModelChange)="onQtyChange()"
    class="custom-input"
  />

  <button (click)="increment()" class="btn btn-plus">
    <mat-icon>add</mat-icon>
  </button>
</div>
